import { tipoDocumentoService } from '@/services/tipoDocumentoService';

const getDefaultState = () => {
  return {
    tiposDocumento: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  tiposDocumento: state => state.tiposDocumento,
  isTiposDocumentoModified: state => !!state.isModified
};

const actions = {
  async fetchTiposDocumento({ commit }) {
    try {
      const response = await tipoDocumentoService.getTiposDocumento();
      commit('SET_TIPOS_DOCUMENTO', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchTiposDocumentoAPI({ commit }) {
    try {
      const response = await tipoDocumentoService.getTiposDocumentoAPI();
      commit('SET_TIPOS_DOCUMENTO', response);
      commit('SET_IS_TIPOS_DOCUMENTO_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
};

const mutations = {
  CLEAR_TIPOS_DOCUMENTO_STATE: state => Object.assign(state, getDefaultState()),
  SET_TIPOS_DOCUMENTO: (state, tiposDocumento) => state.tiposDocumento = tiposDocumento,
  SET_IS_TIPOS_DOCUMENTO_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}